import Forward18 from '@sats-group/icons/18/forward';

import cn from 'classnames';
import React from 'react';
import LinkButton from '@sats-group/fresh-fitness-ui-lib/react/link-button';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import ContentContainer from '../content-container/content-container';

import type { ComponentList as Props } from './component-list.types';

const ComponentList = <T extends { tall?: boolean }>({
  actions,
  description,
  entryRenderer,
  entries,
  title,
}: Props<T> & { entryRenderer: React.FC<T> }) => {
  const EntryRenderer = entryRenderer;
  return (
    <div className="component-list">
      {description || title ? (
        <ContentContainer width={ContentContainer.widths.Medium}>
          <div className="component-list__texts">
            {title ? (
              <Text
                elementName="h2"
                size={Text.sizes.header3}
                variant={Text.variants.hero}
                tight
              >
                {title}
              </Text>
            ) : null}
            {description ? (
              <Text elementName="p" size={Text.sizes.large}>
                {description}
              </Text>
            ) : null}
          </div>
        </ContentContainer>
      ) : null}
      <div
        className={cn('component-list__entries', {
          'component-list__entries--duo': entries.length === 2,
        })}
      >
        {entries.map(item => (
          <div className="component-list__entry" key={item.key}>
            <EntryRenderer {...item.props} tall />
          </div>
        ))}
      </div>
      {actions.length ? (
        <div className="component-list__actions">
          {actions.map(action => (
            <div key={action.href}>
              <LinkButton
                {...action}
                theme={LinkButton.themes.secondary}
                icon={<Forward18 />}
                iconPosition="right"
                wide
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ComponentList;
